export var version = '3.7.1';
//# sourceMappingURL=version.js.map